export default "__VITE_PUBLIC_ASSET__e07395b4__"